//  for fancy
   export const CHAT_CREDS = {
    userToken: 'SFMyNTY.g3QAAAACZAAEZGF0YW0AAAAYNjZmMjVkMWU3Zjc1NTkwMDM3MjNjN2QxZAAGc2lnbmVkbgYArMC7IpIB.ECtG8Fio6sLZbpNQcM1tFCZcVyCRPpFG9BwWMOEpCTA', // rounit

    // userToken: 'SFMyNTY.g3QAAAACZAAEZGF0YW0AAAAYNjZmOTQ4YjYxODU0MmUwMDJkNGRkN2JlZAAGc2lnbmVkbgYAkgjEPZIB.zCigK_h9ii2-UKKgVlnJuA5cZLiCVGwl2C4Ut9OT-ZM', // mir

    // appSecret : will be same for a single applicaton
    appSecret: 'SFMyNTY.g3QAAAACZAAEZGF0YXQAAAADbQAAAAlhY2NvdW50SWRtAAAAGDYxMjUwNDAzMDg4MDg1MDAwMWFhM2Y1Y20AAAAIa2V5c2V0SWRtAAAAJGFlYTkzY2YxLTY5MTYtNDA1MS1iM2I4LWRkMDAyMGViMTU3MW0AAAAJcHJvamVjdElkbQAAACQ3MjNjOTFlYS0xNTdkLTQ2YzMtYTljZS1iNWJiZGYwYmZjN2RkAAZzaWduZWRuBgDXqeZ4hgE.sbacYYKGfKuj-iJnkeV2rFlX6MFDtWOcoLcKL3uW8ic',

    // licenseKey : will be same for a single applicaton
    licenseKey: 'lic-IMKRrezOZJXtmmiUtyJk5ed4ptzoWWa4fU9',

    userSecret: "SFMyNTY.g3QAAAACZAAEZGF0YXQAAAADbQAAAAlhY2NvdW50SWRtAAAAGDY2YjM1ZWI4YTkyODU2MDAzMzFlYjg2Nm0AAAAIa2V5c2V0SWRtAAAAJGExMTdjZmM0LTFiZGQtNDM2Yy1iYTA1LWY4MjZkNDcwNzIyZm0AAAAJcHJvamVjdElkbQAAACQ4ZThjMzM0OS1iMWI0LTRhMTgtOWQ2MS1mNDdkMDA3ODRhZDZkAAZzaWduZWRuBgD3Jq8skQE.1xAAsWeZyLGLkzddin2e8uG-s6qKyPs7EIx4jZnCIb0",

    // accountId: "66b35eb8a9285600331eb866",flex
    accountId: "612504030880850001aa3f5c",

    // keysetId: "a117cfc4-1bdd-436c-ba05-f826d470722f", flex
    keysetId: "aea93cf1-6916-4051-b3b8-dd0020eb1571",

    // projectId: '8e8c3349-b1b4-4a18-9d61-f47d00784ad6',flex
    projectId: '723c91ea-157d-46c3-a9ce-b5bbdf0bfc7d',

    baseUrl: 'https://apis.isometrik.io',

    isometrikUserId: '66f25d1e7f7559003723c7d1'// rounit
    // isometrikUserId: '66f948b618542e002d4dd7be' // mir
  }
export const MQTT_CREDS = {
    URL: "wss://connections.isometrik.io:2053/mqtt",
    UserName:"SFMyNTY.g3QAAAACZAAEZGF0YXQAAAADbQAAAAlhY2NvdW50SWRtAAAAGDY2YjM1ZWI4YTkyODU2MDAzMzFlYjg2Nm0AAAAIa2V5c2V0SWRtAAAAJGExMTdjZmM0LTFiZGQtNDM2Yy1iYTA1LWY4MjZkNDcwNzIyZm0AAAAJcHJvamVjdElkbQAAACQ4ZThjMzM0OS1iMWI0LTRhMTgtOWQ2MS1mNDdkMDA3ODRhZDZkAAZzaWduZWRuBgD3Jq8skQE.dhMCO0iqyKWtfSLQqzUWigBhOQHHe539zcb393bPa1s",
    Password: 'lic-IMK76kZNa/x3Q3mOeC0mwBRy9Fz2dxcqq72'
}


export const isometrikFlutterAppSecrets = {
   licenseKey :'lic-IMKPioj9hM3hMCh5eoeRC+d+l2TuxWOyPK3',
 appSecret :
      'SFMyNTY.g3QAAAACZAAEZGF0YXQAAAADbQAAAAlhY2NvdW50SWRtAAAAGDVlYjNkYjliYTkyNTIwMDAwMTRmODJmZm0AAAAIa2V5c2V0SWRtAAAAJDQwMDYzYWJiLTVhZjEtNGZkNC1hN2YwLWFkYzQ3Njc4MTBiMW0AAAAJcHJvamVjdElkbQAAACRlMTI0MTAzOS0yZmVmLTQ4MzAtYjkyNy01YmIzNDI0ZjE3NjRkAAZzaWduZWRuBgAyRZTfiQE.Cd8oTBl0_bylLMQ45YXxUYqyIhbxstGEwCRIgLlQC3Y',
   userSecret :
      'SFMyNTY.g3QAAAACZAAEZGF0YXQAAAADbQAAAAlhY2NvdW50SWRtAAAAGDVlYjNkYjliYTkyNTIwMDAwMTRmODJmZm0AAAAIa2V5c2V0SWRtAAAAJDQwMDYzYWJiLTVhZjEtNGZkNC1hN2YwLWFkYzQ3Njc4MTBiMW0AAAAJcHJvamVjdElkbQAAACRlMTI0MTAzOS0yZmVmLTQ4MzAtYjkyNy01YmIzNDI0ZjE3NjRkAAZzaWduZWRuBgA2RZTfiQE.ci4LzhsWp_E8bTTFVymYqWrCfCBm92uJ1QlczU1PvbY',
   accountId : '5eb3db9ba9252000014f82ff',
   keysetId : '40063abb-5af1-4fd4-a7f0-adc4767810b1',
   projectId : 'e1241039-2fef-4830-b927-5bb3424f1764',

} //rahul saryam's



export const leOfferChatCreds = {
   userSecret:"SFMyNTY.g3QAAAACZAAEZGF0YXQAAAADbQAAAAlhY2NvdW50SWRtAAAAGDY0YmY2ZTgzM2I1NzhiMDAwMTFmYmEzZm0AAAAIa2V5c2V0SWRtAAAAJGRhNjI3NzU3LTRkZjUtNGEyYy05NDE2LTA3NjM5ODZmNjg0Nm0AAAAJcHJvamVjdElkbQAAACRhNDI0ZDQwMi01NmZkLTQzOTAtODFlZC1hNDA0NWI3ZjJiNWFkAAZzaWduZWRuBgAVptaLiQE.ZPSvNve-q0hXmPSBtUL_q08DqF4vdDR6_vI-UOdPhkw",
projectId:"a424d402-56fd-4390-81ed-a4045b7f2b5a",
licenseKey:"lic-IMKFyE82HC0sgHjIczkGRxm3zL/KfCyUYI/",
appSecret:"SFMyNTY.g3QAAAACZAAEZGF0YXQAAAADbQAAAAlhY2NvdW50SWRtAAAAGDY0YmY2ZTgzM2I1NzhiMDAwMTFmYmEzZm0AAAAIa2V5c2V0SWRtAAAAJGRhNjI3NzU3LTRkZjUtNGEyYy05NDE2LTA3NjM5ODZmNjg0Nm0AAAAJcHJvamVjdElkbQAAACRhNDI0ZDQwMi01NmZkLTQzOTAtODFlZC1hNDA0NWI3ZjJiNWFkAAZzaWduZWRuBgANptaLiQE.vxqtc6_BXKF6nwi51-j4SNIGm1zNCviK9D5pLHCzwH4",
accountId:"64bf6e833b578b00011fba3f", 
// accountId: "687f6d941b8f9d0001ca29d0", // rounit isometrik user id
keySetId:"da627757-4df5-4a2c-9416-0763986f6846",
isometrikUserId: "6863975f22940800019d18f3", // adithyan account if leoffer userid
 userToken: "SFMyNTY.g2gDbQAAABg2ODYzOTc1ZjIyOTQwODAwMDE5ZDE4ZjNuBgBxC-s2mAFiAAFRgA.Dna018k3jqEuIRHPVeS3D6OiPu7X6aaZystK-dNDn3A" // adhtiyan isometrik userToken
}